import { AddFreeTrialApi } from 'api/addFreeTrialApi';
import { FreeTrialSubscriptionApi } from 'api/freeTrialSubscriptionApi';
import { NewSubscriptionApi } from 'api/newSubscriptionApi';
import { SubscribeApi } from 'api/subscribeApi';
import { AppPath } from 'appConstants';
import { useState, useCallback, useEffect } from 'react';

export const useFetchPackages = (pathName: string) => {
  const [packages, setPackages] = useState<any>(null);
  const [vatRate, setVatRate] = useState<number | null>(null);
  const [amountOff, setAmountOff] = useState<number | null>(null);
  const [financeEmail, setFinanceEmail] = useState<any>('');
  const [error, setError] = useState<string>('');

  const getSubscriptionsList = useCallback(async () => {
    let result;
    if (pathName === AppPath.SUBSCRIBE) {
      result = await SubscribeApi.getPackages();
    }
    if (pathName === AppPath.NEW_FREE_TRIAL) {
      result = await AddFreeTrialApi.getPackages();
    }
    if (pathName === AppPath.SUBSCRIBE_FREE_TRIAL) {
      result = await FreeTrialSubscriptionApi.getPackages();
    }
    if (
      pathName === AppPath.NEW_SUBSCRIPTION ||
      pathName === AppPath.UPGRADE_SUBSCRIPTION
    ) {
      result = await NewSubscriptionApi.getPackages();
    }
    if (result.data) {
      setPackages(result.data.generalPackages);
      setVatRate(result.data.vatRate);
      setAmountOff(result.data.amountOff);
      setFinanceEmail(result.data.financeEmail);
    }

    if (result.error) {
      setError(result.error);
    }
  }, []);

  useEffect(() => {
    getSubscriptionsList();
  }, [getSubscriptionsList]);

  return { packages, vatRate, amountOff, financeEmail, error };
};
